import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { PrayerTimes } from "@/components/PrayerTimes";
import { Programs } from "@/components/Programs";
import { Agenda } from "@/components/Agenda";
import { Gallery } from "@/components/Gallery";
import { Donation } from "@/components/Donation";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main className="bg-sand-50" data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <PrayerTimes />
      <Programs />
      <Agenda />
      <Gallery />
      <Donation />
      <Contact />
      <Footer />
    </main>
  );
}
